import React, { ReactNode } from 'react';
import { FlexRow, Header5Text, NumberField, SmallBodyText, TextField } from 'ui-toolkit';
import { ITransaction } from '../../../ui-toolkit/orders/interfaces/ITransaction';

export interface IInlineEditFieldContainerProps {
  field: keyof ITransaction;
  label: string | ReactNode;
  hintText?: ReactNode;
  children: ReactNode;
  isEditing: boolean;
}

const fieldToComponent = {
  loan_amount: NumberField,
  purchase_price: NumberField,
  estimated_property_value: NumberField,
  loan_number: TextField,
};
const editProps = (field: keyof ITransaction) => {
  switch (field) {
    case 'loan_amount':
    case 'purchase_price':
    case 'estimated_property_value':
      return {
        mode: 'currency',
      };
    default:
      return {};
  }
};

export const InlineEditFieldContainer: React.FC<IInlineEditFieldContainerProps> = ({
  field,
  label,
  hintText,
  children,
  isEditing,
}) => {
  const isLabelString = typeof label === 'string';
  const EditControl = fieldToComponent[field];

  return (
    <div>
      <FlexRow justifyContent={'space-between'}>
        {isLabelString && <Header5Text>{label}</Header5Text>}
        {!isLabelString && label}
      </FlexRow>
      <SmallBodyText>
        {!isEditing && children}
        {isEditing && (
          <EditControl {...(editProps(field) as any)} name={field} hintText={hintText} data-test-id={field} />
        )}
      </SmallBodyText>
    </div>
  );
};
